import { Box } from '@mui/material';
import React from 'react';

import { DeviceHardware } from '../../../../../backendsdk';

interface InCabinOverlayProps {
    hardware?: DeviceHardware;
}

export const InCabinOverlay: React.FC<InCabinOverlayProps> = (props: InCabinOverlayProps) => {
    return (
        <Box
            sx={{
                top: '15%',
                bottom: '15%',
                right: '15%',
                left: props.hardware === DeviceHardware.MitacK220 ? '55%' : '15%',
                border: '1px solid white',
                position: 'absolute',
                boxShadow: '0px 0px 5px 1px #000, inset 0px 0px 5px 1px #000',
            }}
        />
    );
};

export default InCabinOverlay;
